const getCampStyleQueryString = (currentSearchQuery) => {
    var _a, _b, _c, _d, _e;
    const campStyle_campCategory = ((_c = (_b = (_a = currentSearchQuery.features) === null || _a === void 0 ? void 0 : _a.campStyle) === null || _b === void 0 ? void 0 : _b.category) === null || _c === void 0 ? void 0 : _c.join(',')) || undefined;
    return {
        campStyle_campCategory,
        campStyle_private: (_e = (_d = currentSearchQuery.features) === null || _d === void 0 ? void 0 : _d.campStyle) === null || _e === void 0 ? void 0 : _e.private,
    };
};
export default getCampStyleQueryString;
